import { PayPalScriptProvider } from "@paypal/react-paypal-js";

const getClientId = () => {
  return "AZvILA074Y9HNN0xTA4bmNTgH7J1DoIkQ6PgQ1iem3xqXC-DvV9vHot74Lis0FXSEWrUlQLJU1McFPmn";
};

const initialOptions = {
  clientId: getClientId(),
  currency: "USD",
  intent: "subscription",
  enableFunding: ["paypal"],
  disableFunding: ["card", "paylater"],
  vault: true,
  components: ["buttons"],
};

export function PayPalProvider({ children }: { children: React.ReactNode }) {
  return (
    <PayPalScriptProvider options={initialOptions}>
      {children}
    </PayPalScriptProvider>
  );
}
